import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Box } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const ArrowUp = styled(Box)`
  z-index: ${themeGet('zIndices.loginToolTip')};
  margin-bottom: -1px;
  align-self: flex-end;
  margin-right: ${themeGet('space.8')};
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid ${themeGet('colors.white')};

  ${mediaQuery.minWidth.sm} {
    border-bottom: 10px solid ${themeGet('colors.snow')};
  }
`;

export const ArrowRight = styled(Box)`
  align-self: center;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid ${themeGet('colors.white')};
`;

export const Card = styled(Flex)`
  z-index: ${themeGet('zIndices.stickyCampaignMessaging')};
  height: 74px;
  padding: ${themeGet('space.4')};
  background: linear-gradient(-180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 35%, #E6E6E6 100%);
  border-top: 1px solid ${themeGet('colors.greys.alto')};
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};
  box-shadow: ${themeGet('shadows.hover')};
  
  ${mediaQuery.minWidth.md} {
    border-top: 0px;
    border-radius: 0 0 0 ${themeGet('radii.default')};
  }
}
`;
